import { useState, useEffect } from 'react';
import { SWEEPSTAKES_MOCK_DATA } from '../core/Data/SweepstakesMockData';

export const useFetchSweepstakes = (sweepstakesId, userOptInStatus = 'notOptedIn') => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const fetchSweepstakesData = async () => {
      setIsLoading(true);
      setHasError(false);

      try {
        // Simulate network delay
        await new Promise((resolve) => {
          setTimeout(resolve, 1000);
        });

        // Mock API response based on user status
        let mockData;
        switch (userOptInStatus) {
        case 'notOptedIn':
          mockData = SWEEPSTAKES_MOCK_DATA.notOptedIn;
          break;
        case 'partiallyCompleted':
          mockData = SWEEPSTAKES_MOCK_DATA.partiallyCompleted;
          break;
        case 'fullyCompleted':
          mockData = SWEEPSTAKES_MOCK_DATA.fullyCompleted;
          break;
        default:
          mockData = SWEEPSTAKES_MOCK_DATA.notOptedIn;
        }

        setData(mockData);
      } catch (error) {
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };

    if (sweepstakesId) {
      fetchSweepstakesData();
    }
  }, [sweepstakesId, userOptInStatus]);

  const acceptSweepstakes = async () => {
    try {
      // Simulate accepting sweepstakes
      await new Promise((resolve) => {
        setTimeout(resolve, 500);
      });

      // Update data to show opted in status
      setData((prevData) => ({
        ...prevData,
        isOptedIn: true,
        status: '0 of 4 Completed',
      }));

      return { success: true };
    } catch (error) {
      return { success: false, error };
    }
  };

  return {
    data,
    isLoading,
    hasError,
    acceptSweepstakes,
  };
};